import { checkPassword } from "@iscr/xAppLib/Users/passwordValidation";
import { useMemo } from 'react';
import { Icon } from "semantic-ui-react";

const getRuleIcon = rule => {
	if (rule.pass === true) return "check";
	if (rule.pass === false) return "times";
	return "info circle";
};

const getRuleClass = rule => {
	if (rule.pass === true) return "text-green-600";
	if (rule.pass === false) return "text-red-500";
	return "text-gray-500";
};

export const PasswordChecklist = ({ password }) => {
	const rules = useMemo(() => checkPassword(password), [password]);

	return (
		<div className="text-is2-gray-150 text-sm mb-5">
			<b>Password Requirements:</b>
			<ul>
				{rules.map(rule => (
					<li key={rule.id} className={getRuleClass(rule)}>
						<Icon name={getRuleIcon(rule)} /> {rule.hint}
					</li>
				))}
			</ul>
		</div>
	);
};
